;(() => {
  const OMNI = '.kl-teaser-RhXqr4';
  const TARGET = '#google-merchantwidget-iframe-wrapper';

  const update = () => {
    const t = document.querySelector(TARGET);
    if (!t) return;

    const o = document.querySelector(OMNI);

    const force5 =
      !o || o.style.display === 'none';

    t.style.setProperty(
      'bottom',
      force5 ? '5px' : '125px',
      'important'
    );
  };

  update();

  new MutationObserver(update).observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['style'],
  });
})();
